const SCRIPT_TAG_PATTERN =
  /<\/?script\b[^>]*>(?:[\s\S]*?(?:<\/script\b[^>]*>|$))?/gi
const STYLE_TAG_PATTERN =
  /<\/?style\b[^>]*>(?:[\s\S]*?(?:<\/style\b[^>]*>|$))?/gi

export const sanitizeGalleryDescriptionHtml = (html: string): string => {
  return html.replace(SCRIPT_TAG_PATTERN, '').replace(STYLE_TAG_PATTERN, '')
}
